{% block sw_cms_element_acris_blog_group %}
    <div class="sw-cms-el-acris-blog-group">
        <h4>{{ $tc('acris-blog.elements.blogGroup.label') }}</h4>

        <div v-if="element.config.layout.value === 'box'" class="sw-cms-el-acris-blog-group-box-container">
            <!-- Row 1 -->
            <div class="sw-cms-el-acris-blog-group-row">
                <div v-for="index in 4" class="sw-cms-el-acris-blog-group-card">
                    <img class="sw-cms-el-acris-blog-group-card-image"
                         :src="assetFilter('/administration/administration/static/img/cms/preview_glasses_small.jpg')">
                    <div class="sw-cms-el-acris-blog-group-card-content">
                        <h3 class="sw-cms-el-acris-blog-group-card-blog-title">
                            {{ $tc('acris-blog.elements.blogGroup.blogName') }} {{ index }}</h3>
                        <div class="sw-cms-el-acris-blog-group-card-date">26/10/2025</div>
                    </div>
                    <div class="sw-cms-el-acris-blog-group-card-read-more-btn">{{ $tc('acris-blog.elements.blogGroup.readMore') }}</div>
                </div>
            </div>

            <!-- Row 2 -->
            <div class="sw-cms-el-acris-blog-group-row">
                <div v-for="index in 4" class="sw-cms-el-acris-blog-group-card">
                    <img class="sw-cms-el-acris-blog-group-card-image"
                         :src="assetFilter('/administration/administration/static/img/cms/preview_glasses_small.jpg')">
                    <div class="sw-cms-el-acris-blog-group-card-content">
                        <h3 class="sw-cms-el-acris-blog-group-card-blog-title">{{ $tc('acris-blog.elements.blogGroup.blogName') }} {{ 4 + index }}</h3>
                        <div class="sw-cms-el-acris-blog-group-card-date">26/10/2025</div>
                    </div>
                    <div class="sw-cms-el-acris-blog-group-card-read-more-btn">{{ $tc('acris-blog.elements.blogGroup.readMore') }}</div>
                </div>
            </div>
        </div>

        <div v-else class="sw-cms-el-acris-blog-group-list-container">
            <div v-for="index in 2" class="sw-cms-el-acris-blog-group-list-item">
                <div class="sw-cms-el-acris-blog-group-list-image-card">
                    <img class="sw-cms-el-acris-blog-group-list-image"
                         :src="assetFilter('/administration/administration/static/img/cms/preview_glasses_small.jpg')">
                </div>
                <div class="sw-cms-el-acris-blog-group-list-content">
                    <div>
                        <div class="sw-cms-el-acris-blog-group-list-header">
                            <h3 class="sw-cms-el-acris-blog-group-list-title">{{ $tc('acris-blog.elements.blogGroup.blogName') }} {{ index }}</h3>
                            <div class="sw-cms-el-acris-blog-group-list-date">26/10/2025</div>
                        </div>
                    </div>
                    <a href="#" class="sw-cms-el-acris-blog-group-list-read-more-btn">{{ $tc('acris-blog.elements.blogGroup.readMore') }}</a>
                </div>
            </div>
        </div>
    </div>
{% endblock %}
